import { render, staticRenderFns } from "./ShoppingListItem.vue?vue&type=template&id=622ee979&"
import script from "./ShoppingListItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports